import { useMemo, useState } from 'react';

export default function useCantinaCart() {
  const [carrito, setCarrito] = useState([]);

  const agregar = (producto) => {
    if (!producto) return;

    setCarrito((actual) => {
      const existente = actual.find(
        (item) => item.id === producto.id
      );

      if (existente) {
        return actual.map((item) =>
          item.id === producto.id
            ? { ...item, cantidad: item.cantidad + 1 }
            : item
        );
      }

      return [
        ...actual,
        {
          ...producto,
          cantidad: 1,
        },
      ];
    });
  };

  const cambiarCantidad = (id, delta) => {
    setCarrito((actual) =>
      actual
        .map((item) =>
          item.id === id
            ? {
                ...item,
                cantidad: Math.max(
                  0,
                  item.cantidad + delta
                ),
              }
            : item
        )
        .filter((item) => item.cantidad > 0)
    );
  };

  const quitar = (id) => {
    setCarrito((actual) =>
      actual.filter((item) => item.id !== id)
    );
  };

  const vaciar = () => setCarrito([]);

  const total = useMemo(
    () =>
      carrito.reduce(
        (sum, item) =>
          sum + Number(item.precio) * item.cantidad,
        0
      ),
    [carrito]
  );

  const unidades = useMemo(
    () =>
      carrito.reduce(
        (sum, item) => sum + item.cantidad,
        0
      ),
    [carrito]
  );

  return {
    carrito,
    agregar,
    cambiarCantidad,
    quitar,
    vaciar,
    total,
    unidades,
  };
}
